<template>
  <NxInput
    name="descricaoProfissao"
    type="text"
    label="Descrição Profissão:"
    placeholder="Digite descrição da profissão"
    :value="localValue"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDescricaoProfissao',
  mixins: [useReactiveModelMixin('value')],
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDescricaoProfissao.vue